import React, { useEffect } from 'react';
import { TrackingFunction } from './types';

export type TrackOnChangePropsType = {
  track: TrackingFunction;
  trackingMessage: string;
  trackingProps?: any;
  children: React.ReactNode;
};

const TrackOnChange = ({
  track,
  trackingMessage,
  trackingProps = {},
  children,
}: TrackOnChangePropsType) => {
  useEffect(() => {
    track(trackingMessage, trackingProps);
  }, [track, trackingMessage, trackingProps]);

  return children;
};

export default TrackOnChange;
